import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  TransparentScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_TransparentScreen" */ './viewer/skinComps/BaseScreen/TransparentScreen.skin'
    ),
  ],
  DefaultScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_DefaultScreen" */ './viewer/skinComps/DefaultScreen/DefaultScreen.skin'
    ),
  ],
  WoodScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_WoodScreen" */ './viewer/skinComps/BaseScreen/WoodScreen.skin'
    ),
  ],
  LineBottomScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_LineBottomScreen" */ './viewer/skinComps/BaseScreen/LineBottomScreen.skin'
    ),
  ],
  NoiseScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_NoiseScreen" */ './viewer/skinComps/BaseScreen/NoiseScreen.skin'
    ),
  ],
  SolidScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_SolidScreen" */ './viewer/skinComps/BaseScreen/SolidScreen.skin'
    ),
  ],
  BoxScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_BoxScreen" */ './viewer/skinComps/BaseScreen/BoxScreen.skin'
    ),
  ],
  DoubleBorderScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_DoubleBorderScreen" */ './viewer/skinComps/DoubleBorderScreen/DoubleBorderScreen.skin'
    ),
  ],
  IronScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_IronScreen" */ './viewer/skinComps/IronScreen/IronScreen.skin'
    ),
  ],
  ShadowBottomScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_ShadowBottomScreen" */ './viewer/skinComps/ShadowBottomScreen/ShadowBottomScreen.skin'
    ),
  ],
  LiftedBottomScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_LiftedBottomScreen" */ './viewer/skinComps/LiftedBottomScreen/LiftedBottomScreen.skin'
    ),
  ],
  LiftedTopScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_LiftedTopScreen" */ './viewer/skinComps/LiftedTopScreen/LiftedTopScreen.skin'
    ),
  ],
  ThreeDeeScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_ThreeDeeScreen" */ './viewer/skinComps/ThreeDeeScreen/ThreeDeeScreen.skin'
    ),
  ],
  InnerShadowScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_InnerShadowScreen" */ './viewer/skinComps/InnerShadowScreen/InnerShadowScreen.skin'
    ),
  ],
  BevelScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_BevelScreen" */ './viewer/skinComps/BevelScreen/BevelScreen.skin'
    ),
  ],
  BlankScreen: () => [
    import(
      /* webpackChunkName: "HeaderContainer_BlankScreen" */ './viewer/skinComps/BaseScreen/BlankScreen.skin'
    ),
  ],
  AfterScroll: () => [
    import(
      /* webpackChunkName: "HeaderContainer_AfterScroll" */ './viewer/skinComps/AfterScroll/AfterScroll.skin'
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('HeaderContainer', UiTypes),
};

export default entry;
